"use strict";
document.querySelectorAll(".faq-page .question h3").forEach(function (singleButton) {
    singleButton.addEventListener('click', function () {
        var _a, _b;
        singleButton.classList.toggle('open');
        (_b = (_a = singleButton.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('.answer')) === null || _b === void 0 ? void 0 : _b.classList.toggle('hidden');
    });
});
